import { gql } from '@apollo/client';

export const AppMembershipFragment = gql`
  fragment AppMembershipFragment on AppMembership {
    id
    user {
      id
      name
      email
      phone
      role
    }
    role
    policy {
      remove
      update
    }
  }
`;
